export const categories = [
  {
    id: 'jiejie-pengyouquan',
    name: '姐姐的朋友圈拓展',
    slug: 'jiejie-pengyouquan',
    description: '学习如何借助姐姐的社交圈，优雅地拓展你的人脉网络，让姐姐的朋友成为你的朋友',
    image: 'https://readdy.ai/api/search-image?query=Warm%20artistic%20illustration%20of%20two%20elegant%20women%20having%20a%20friendly%20conversation%20in%20a%20cozy%20cafe%20setting%2C%20soft%20amber%20and%20coral%20tones%2C%20intimate%20atmosphere%2C%20gentle%20natural%20light%2C%20editorial%20style%2C%20harmonious%20composition%2C%20warm%20connection%20between%20people&width=800&height=600&seq=cat-sister-circle&orientation=landscape',
    articleCount: 3,
    icon: 'ri-group-line',
  },
  {
    id: 'kuajuan-shejiao',
    name: '跨圈社交方法',
    slug: 'kuajuan-shejiao',
    description: '掌握跨圈社交的核心法则，打破社交壁垒，在不同圈子之间自如切换',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20illustration%20of%20overlapping%20translucent%20circles%20in%20warm%20coral%20and%20muted%20sage%20green%20tones%2C%20representing%20diverse%20social%20circles%20intersecting%2C%20minimalist%20composition%2C%20soft%20gradient%20background%2C%20editorial%20style%2C%20harmonious%20and%20sophisticated%20aesthetic&width=800&height=600&seq=cat-cross-circle&orientation=landscape',
    articleCount: 2,
    icon: 'ri-exchange-line',
  },
  {
    id: 'renmai-weihu',
    name: '人脉维护技巧',
    slug: 'renmai-weihu',
    description: '建立人脉只是第一步，学会长期维护关系才是社交高手的关键所在',
    image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20illustration%20of%20intertwined%20golden%20threads%20forming%20a%20delicate%20web%20pattern%2C%20soft%20amber%20and%20cream%20background%2C%20representing%20carefully%20maintained%20relationships%2C%20elegant%20composition%2C%20gentle%20lighting%2C%20editorial%20aesthetic%2C%20harmonious%20and%20refined&width=800&height=600&seq=cat-network-maintain&orientation=landscape',
    articleCount: 2,
    icon: 'ri-hearts-line',
  },
  {
    id: 'shejiao-xinlixue',
    name: '社交心理学',
    slug: 'shejiao-xinlixue',
    description: '从心理学角度理解人际交往的底层逻辑，让你在社交中更加游刃有余',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20illustration%20of%20a%20warm%20glowing%20brain%20with%20soft%20flowing%20lines%20connecting%20to%20small%20dots%20representing%20social%20connections%2C%20amber%20and%20terracotta%20color%20palette%2C%20minimalist%20composition%2C%20editorial%20style%2C%20gentle%20gradients%2C%20sophisticated%20and%20calm%20atmosphere&width=800&height=600&seq=cat-social-psych&orientation=landscape',
    articleCount: 3,
    icon: 'ri-brain-line',
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});